import axios from 'axios';
import { API_URL } from '../../constants/config';
import ls from 'localstorage-slim';

// enable global encryption
ls.config.encrypt = true;
export const getAssignedPrograms = async ({ orgId, ...payload }) => {
  const { member, role, ...params } = payload;
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/user/assigned-program/get`, { member, role }, { headers, params });
  } catch (err) {
    throw new Error(err);
  }
};

export const getTutorProgramLearners = async ({ orgId, ...payload }) => {
  const { member, role, programId, ...params } = payload;
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/user/assigned-program/get/apprentices`, { member, role, programId }, { headers, params });
  } catch (err) {
    throw new Error(err);
  }
};

export const getProgramTutors = async ({ orgId, ...payload }) => {
  const { program, role, ...params } = payload;
  const headers = {
    Authorization: `Bearer ${ls.get('token')}`,
    organisationid: ls.get('orgId'),
  };
  try {
    return await axios.post(`${API_URL}/admin/program/assigned-users`, { program, role }, { headers, params });
  } catch (err) {
    throw new Error(err);
  }
};

export const assignPrograms = async (payload) => {
  const headers = {
    headers: {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    },
  };
  try {
    return await axios.post(`${API_URL}/user/assigned-program/create`, payload, headers);
  } catch (err) {
    throw new Error(err);
  }
};

export const unAssignTutorPrograms = async (payload) => {
  const headers = {
    headers: {
      Authorization: `Bearer ${ls.get('token')}`,
      organisationid: ls.get('orgId'),
    },
  };
  try {
    return await axios.post(`${API_URL}/user/assigned-program/unassign/programs`, payload, headers);
  } catch (err) {
    throw new Error(err);
  }
};
